import CommonThemeSelection from '../../../../../components/common/CommonThemeSelection';
import ThemePreviewCard from './ThemePreviewCard';
import { _ThemeColorsType } from '../../../../../constants/staticTypes';

type Props = {
    isDefaultTheme: boolean;
    setIsDefaultTheme: React.Dispatch<React.SetStateAction<boolean>>;
    customColors: _ThemeColorsType;
    setCustomColors: React.Dispatch<React.SetStateAction<_ThemeColorsType>>;
    defaultColors?: _ThemeColorsType;
};

export default function ThemeSelection({
    isDefaultTheme,
    setIsDefaultTheme,
    customColors,
    setCustomColors,
    defaultColors,
}: Readonly<Props>) {
    return (
        <CommonThemeSelection
            isDefaultTheme={isDefaultTheme}
            setIsDefaultTheme={setIsDefaultTheme}
            customColors={customColors}
            setCustomColors={setCustomColors}
            defaultColors={defaultColors}
            ThemePreviewComponent={ThemePreviewCard}
        />
    );
}
